import Icon from "@components/ui/icon";
import { useCheckoutDetails } from "../hooks";
import { usePurchaseSubscriptionStore } from "../store";

const ROW_STYLE =
  "tw-flex tw-items-center tw-justify-between tw-py-3 tw-font-sans tw-text-sm/tight tw-font-normal tw-text-primary-50";

const CheckoutDetails = ({
  plan,
  period,
  initiatePaddle,
}: {
  plan: string;
  period: string;
  initiatePaddle: () => void;
}) => {
  const { details } = useCheckoutDetails({
    plan,
    period,
  });
  const { setIsCheckoutStep } = usePurchaseSubscriptionStore();
  const isYearly = period === "annually";

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          setIsCheckoutStep(false);
          initiatePaddle();
        }}
        className="tw-mb-4 tw-inline-flex tw-size-6 tw-outline-none tw-cursor-pointer tw-items-center tw-justify-start tw-transition-opacity hover:tw-opacity-80"
      >
        <Icon
          icon="ri-arrow-left-line"
          className="tw-text-2xl tw-text-primary-400"
        />
      </button>
      <h3 className="tw-mb-2 tw-mt-0 tw-pb-6 tw-text-2xl tw-font-bold tw-text-white">
        Checkout
      </h3>
      <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
      <div>
        <div className={ROW_STYLE}>
          <span>Monthly price</span>
          <span>
            {details?.currency}
            {details?.monthlyPrice}
          </span>
        </div>
        <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
        <div className={ROW_STYLE}>
          <span>Billing period</span>
          <span>{details?.billingPeriod}</span>
        </div>
        <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
        <div className={ROW_STYLE}>
          {isYearly ? (
            <span className="tw-font-semibold">Subtotal (before discount)</span>
          ) : (
            <span>Subtotal</span>
          )}
          <span>
            {details?.currency}
            {details?.subtotal}
          </span>
        </div>
        <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
        {isYearly && (
          <>
            <div className={ROW_STYLE}>
              <span>Annual discount ({details?.discountPercentage}% Off)</span>
              <span className="tw-text-golden">
                -{details?.currency}
                {details?.annualDiscount}
              </span>
            </div>
            <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
            <div className={ROW_STYLE}>
              <span className="tw-font-semibold">Discounted subtotal</span>
              <span>
                {details?.currency}
                {details?.discountedSubtotal}
              </span>
            </div>
            <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
          </>
        )}
        <div className={ROW_STYLE}>
          <span>Sales Tax ({details?.taxValue}%)</span>
          <span>
            {details?.currency}
            {details?.tax_after_discount}
          </span>
        </div>
        <hr className="tw-m-0 tw-h-[1px] tw-w-full tw-bg-primary/30" />
        <div className="tw-flex tw-items-center tw-justify-between tw-pt-6 tw-font-sans tw-text-lg tw-font-semibold tw-text-primary-50">
          <span>Due today</span>
          <span>
            {details?.currency}
            {details?.gross_after_discount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CheckoutDetails;
